module.exports = __webpack_public_path__ + "Layers.png";